import { render, staticRenderFns } from "./ListIncident.vue?vue&type=template&id=31cf9e84"
import script from "./ListIncident.vue?vue&type=script&lang=js"
export * from "./ListIncident.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports